namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

	export interface IUser {
		userId: number;
		userName: string;
		role: string;
		firstName: string;
		lastName: string;
		phone: ContactInfo;
		fax: ContactInfo;
		email: ContactInfo;
		sid: string;
		accountId: number;
		userDomainId: number;
		active: boolean;
	}

	export class User implements IUser {
		userId: number;
		userName: string;
		role: string;
		firstName: string;
		lastName: string;
		phone: ContactInfo;
		fax: ContactInfo;
		email: ContactInfo;
		sid: string;
		accountId: number;
		userDomainId: number;
		active: boolean;

		constructor(obj?: IUser | psgm.ScriptsAuthenticationGetCurrentUserGetCurrentUserResponseModel | any) {
			this.userId = null;
			this.userName = '';
			this.role = null;
			this.firstName = ''
			this.lastName = '';
			this.phone = new ContactInfo();
			this.fax = new ContactInfo();
			this.email = new ContactInfo();
			this.sid = null;
			this.accountId = null;
			this.userDomainId = null;
			this.active = false;

			if (obj) {
				this.userId = obj.userId || null;
				this.userName = obj.userName || '';
				this.role = obj.role || null;
				this.firstName = obj.firstName || '';
				this.lastName = obj.lastName || '';

				if (obj.phone) {
					this.phone = new ContactInfo(obj.phone);
				}

				if (obj.fax) {
					this.fax = new ContactInfo(obj.fax);
				}

				if (obj.email) {
					this.email = new ContactInfo(obj.email);
				}

				this.sid = obj.sid || null;
				this.accountId = obj.accountId || null;
				this.userDomainId = obj.userDomainId || null;
				this.active = obj.active || false;
            }
        }
	}

    export interface IContactInfo {
		value: string;
		isPreferred: boolean;
	}

	export class ContactInfo implements IContactInfo {
		value: string;
		isPreferred: boolean;

		constructor(obj?: IContactInfo | psgm.ScriptsAuthenticationGetCurrentUserGetCurrentUserContactInfoResponseModel) {
			this.value = '';
			this.isPreferred = false;

			if (obj) {
				this.value = obj.value || '';
				this.isPreferred = obj.isPreferred || false;
			}
		}
	}
}
